import React, {useEffect, useState} from 'react'
import classes from './ScraperPage.module.css'
import firebase from "../../../Config/firebase";
import {MDBAlert, MDBBtn, MDBCol, MDBContainer, MDBRow, MDBTable, MDBTableBody, MDBTableHead} from "mdbreact";
import ApprovalItem from "../ApprovalPage/ApprovalItem/ApprovalItem";
import {Trans} from "react-i18next";
import Select from "react-select";
import {getAllTypes} from "../../../Utils/type";
import {getAllCategories, getSubCategories} from "../../../Utils/category";
import {countries as countriesCode} from "../../../Utils/countries";
import ScraperItem from "./ScraperItem/ScraperItem";
import ResultItem from "../../CategoryPage/ResultItem/ResultItem";
import ContentLoader from "react-content-loader";
import {getAPIPath} from "../../../Utils/HelpingFunction";

const db = firebase.firestore()

const countryOptArr = []
const ScraperPage = (props) => {
    const [newPendingRequest, setNewPendingRequest] = useState({
        id: 0,
        country: '344',
        type: '',
        category: "",
        subCategory: "",
        description: "",
        url: '',
        title: "",
        public: false,
        imageSrc: "",
        numberOfMember: 0,
    })
    const [hasNewItem, setHasNewItem] = useState(false)

    const [listScraper, setListScraper] = useState([])
    const [isLoaded, setIsLoaded] = useState(false)
    const [noItem, setNoItem] = useState(false)

    const [submitting, setSubmitting] = useState(false)
    const [submitted, setSubmitted] = useState(false)
    const [hasError, setHasError] = useState(false)

    const [isSearchDone, setIsSearchDone] = useState(false)
    const [searchQuery, setSearchQuery] = useState("")
    const [searchResult, setSearchResult] = useState([])
    const [noSearchResult, setNoSearchResult] = useState(false)

    const [requireReload, setRequireReload] = useState(false)
    const [requireFullReload, setRequireFullReload] = useState(false)

    useEffect(() => {
        countryOptions()
        getScraperItems()
    }, [])

    const countryOptions = () => {
        countriesCode.map((country) => {
            countryOptArr.push({value: country.num_code, label: country.en_short_name});
        })
    }

    const getScraperItems = () => {
        let allItems = []
        db.collection('Scraper')
            .limit(20)
            .get()
            .then(docs => {
                if (!docs.empty) {
                    docs.forEach(doc => {
                        allItems.push({
                            ...doc.data(),
                            id: doc.id
                        })
                    })

                    setListScraper(allItems)
                    setIsLoaded(true)
                } else {
                    setNoItem(false)
                    setIsLoaded(true)
                }
            })
            .catch(err => console.log(err))
    }

    const onSearchStart = (searchQuery) => {
        setNoSearchResult(false)
        setIsSearchDone(false)
        setSearchQuery(searchQuery)
        return new Promise(async (resolve, reject) => {
            await fetch(getAPIPath("/api/search/all"), {
                method: 'POST',
                headers: {"Content-Type": "application/json"},
                body: JSON.stringify({
                    uid: props.auth.uid,
                    searchStr: searchQuery
                })
            })
                .then((res) => res.json()).then((response) => {
                    console.log(response)
                    if (response.success) {
                        if (response.data.length === 0) {
                            setNoSearchResult(true)
                            setIsSearchDone(true)
                        } else {
                            setSearchResult(response.data)
                            setIsSearchDone(true)
                        }
                    }

                })
        })
    }

    //in here approvalItem mean open input box
    const setPendingItem = async (item) => {
        setNewPendingRequest({
            id: item.id,
            country: '344',
            type: '',
            category: "",
            subCategory: "",
            description: "",
            url: 'https://mewe.com' + item.url,
            title: item.title,
            public: item.public,
            imageSrc: item.imageSrc,
            numberOfMember: item.numberOfMember,
        })
        setHasNewItem(true)
        onSearchStart(item.title.split(" ")[0])
    }

    const rejectPendingItem = async (id) => {
        db.collection('Scraper')
            .doc(id)
            .delete()
            .then(res => {
                removeListItem(id)
            })
    }

    const submitItem = async () => {
        return await new Promise((resolve, reject) => {
            fetch(getAPIPath("/api/admin/addScraperItem"), {
                method: 'POST',
                headers: {"Content-Type": "application/json"},
                body: JSON.stringify({
                    uid: props.auth.uid,
                    item: newPendingRequest
                })
            }).then((res) => res.json()).then((searchResult) => {
                if (searchResult.success) {
                    setSubmitting(false)
                    removeListItem(newPendingRequest.id)
                    setRequireFullReload(true)
                    setNewPendingRequest({
                        id: 0,
                        country: '344',
                        type: '',
                        category: "",
                        subCategory: "",
                        description: "",
                        url: '',
                        title: "",
                        public: false,
                        imageSrc: "",
                        numberOfMember: 0,
                    })
                    setTimeout(() => {
                        setRequireFullReload(false)
                        setSubmitted(false)
                    }, 1500)
                }
            })
        })
    }

    const removeListItem = (id) => {
        let newItems = listScraper
        newItems = newItems.filter(e => e.id !== id)
        setListScraper(newItems)
    }

    const updateExistValue = (id) => {
        console.log(id)
        setSubmitting(true)
        db.collection('Data')
            .doc(id)
            .update({
                public: newPendingRequest.public,
                imageSrc: newPendingRequest.imageSrc,
                numberOfMember: newPendingRequest.numberOfMember,
                lastModified: new Date()
            })
            .then(res => {
                setNewPendingRequest({
                    id: 0,
                    country: '344',
                    type: '',
                    category: "",
                    subCategory: "",
                    description: "",
                    url: '',
                    title: "",
                    public: false,
                    imageSrc: "",
                    numberOfMember: 0,
                })

                rejectPendingItem(newPendingRequest.id)
                setSubmitted(true)
                setSubmitting(false)
                setRequireFullReload(true)
                setTimeout(() => {
                    setRequireFullReload(false)
                    setSubmitted(false)
                }, 1500)
            })
    }


    return (
        <MDBContainer>
            <MDBRow>
                <MDBCol>
                    {
                        hasNewItem &&
                        <div className={classes.TopContainer}>
                            <div>
                                <div className={classes.InputForm}>
                                    <div className={classes.InputFormItems}>
                                        <div className={classes.InputFormItem}>
                                            <label className={classes.Label}>
                                                <Trans>Homepage.country</Trans>
                                            </label>
                                            {
                                                requireFullReload ? "" :
                                                    <Select
                                                        isDisabled={submitting}
                                                        name="nationality"
                                                        defaultValue={{label: "Hong Kong", value: "344"}}
                                                        closeMenuOnSelect={true}
                                                        options={countryOptArr}
                                                        className={newPendingRequest.country === '' ? classes.WarningSelect : ''}
                                                        // isDisabled={!this.state.editLanguage}
                                                        onChange={(e) => {
                                                            setNewPendingRequest({
                                                                ...newPendingRequest,
                                                                country: e.value.toString()
                                                            })
                                                        }}
                                                    />
                                            }
                                        </div>

                                        <div className={classes.InputFormItem}>
                                            <label className={classes.Label}>
                                                <Trans>Homepage.type</Trans>
                                            </label>
                                            {
                                                requireFullReload ? "" :
                                                    <Select
                                                        name="type"
                                                        isDisabled={submitting}
                                                        closeMenuOnSelect={true}
                                                        options={getAllTypes()}
                                                        className={newPendingRequest.type === '' ? classes.WarningSelect : ''}
                                                        // isDisabled={!this.state.editLanguage}
                                                        onChange={(e) => {
                                                            setNewPendingRequest({
                                                                ...newPendingRequest,
                                                                type: e.value.toString()
                                                            })
                                                        }}
                                                    />
                                            }
                                        </div>

                                        <div className={classes.InputFormItem}>
                                            <label className={classes.Label}>
                                                <Trans>Homepage.category</Trans>
                                            </label>
                                            {
                                                requireFullReload ? "" :
                                                    <Select
                                                        name="type"
                                                        isDisabled={submitting}
                                                        closeMenuOnSelect={true}
                                                        options={getAllCategories()}
                                                        className={newPendingRequest.category === '' ? classes.WarningSelect : ''}
                                                        // isDisabled={!this.state.editLanguage}
                                                        onChange={(e) => {
                                                            setRequireReload(true)
                                                            setNewPendingRequest({
                                                                ...newPendingRequest,
                                                                category: e.value.toString()
                                                            })
                                                            setTimeout(() => {
                                                                setRequireReload(false)
                                                            }, 200)
                                                        }}
                                                    />
                                            }
                                        </div>

                                        <div className={classes.InputFormItem}>
                                            <label className={classes.Label}>
                                                <Trans>Homepage.sub-category</Trans> {newPendingRequest.category}
                                            </label>
                                            {
                                                requireReload && newPendingRequest.category !== '' ? "" :
                                                    <Select
                                                        name="type"
                                                        isDisabled={submitting}
                                                        closeMenuOnSelect={true}
                                                        options={getSubCategories(newPendingRequest.category)}
                                                        className={newPendingRequest.subCategory === '' ? classes.WarningSelect : ''}
                                                        // isDisabled={!this.state.editLanguage}
                                                        onChange={(e) => {
                                                            setNewPendingRequest({
                                                                ...newPendingRequest,
                                                                subCategory: e.value.toString()
                                                            })
                                                        }}
                                                    />
                                            }

                                        </div>
                                    </div>

                                    <div className={classes.DescriptionContainer}>
                                        <div className={classes.InputFormItem}>
                                            <label className={classes.Label}>
                                                <Trans>Homepage.title</Trans>
                                            </label>
                                            <input type='text'
                                                   disabled={submitting}
                                                   placeholder={'e.g. MeWe 最新資訊'}
                                                   className={classes.InputField}
                                                   value={newPendingRequest.title}
                                                   onChange={(e) => setNewPendingRequest({
                                                       ...newPendingRequest,
                                                       title: e.target.value
                                                   })}/>
                                        </div>

                                        <div className={classes.InputFormItem}>
                                            <label className={classes.Label}>
                                                <Trans>Homepage.URL</Trans>
                                            </label>
                                            <input type='text'
                                                   disabled={submitting}
                                                   placeholder={'e.g. https://mewe.com/group/55f9dd29e4b050c69e693558'}
                                                   className={classes.InputField}
                                                   value={newPendingRequest.url}
                                                   onChange={(e) => setNewPendingRequest({
                                                       ...newPendingRequest,
                                                       url: e.target.value.replaceAll(" ", "")
                                                   })}/>
                                        </div>

                                        <textarea className={classes.Description}
                                                  placeholder={'介紹 e.g. MEWE新聞和更新'}
                                                  disabled={submitting}
                                                  value={newPendingRequest.description}
                                                  onChange={(e) => {
                                                      setNewPendingRequest({
                                                          ...newPendingRequest,
                                                          description: e.target.value
                                                      })
                                                  }}
                                        />
                                    </div>
                                </div>
                                <div className={classes.CardBottom}>
                                    {
                                        hasError &&
                                        <MDBAlert color='danger'>
                                            <Trans>Homepage.require-fill-in</Trans>
                                        </MDBAlert>
                                    }
                                    <MDBBtn color={submitting ? 'warning' : submitted ? 'success' : 'primary'}
                                            className={classes.SubmitBtn}
                                            onClick={() => {
                                                setSubmitting(true)
                                                submitItem()
                                            }}
                                    >
                                        {submitting ? "loading..." : submitted ? <Trans>Homepage.done</Trans> :
                                            <Trans>Homepage.submit</Trans>}
                                    </MDBBtn>
                                </div>
                            </div>
                            <div className={classes.SearchResultContainer}>
                                <input type='text'
                                       className={classes.SearchInput}
                                       placeholder={'search...'}
                                       value={searchQuery}
                                       onChange={(e) => onSearchStart(e.target.value)}
                                />
                                <div className={classes.SearchResult}>
                                    {
                                        isSearchDone ?
                                            !noSearchResult ?
                                                searchResult.map(data => {
                                                    return (
                                                        <ResultItem
                                                            type={'admin'}
                                                            key={data.objectID}
                                                            data={data}
                                                            updateExistValue={updateExistValue}
                                                        />
                                                    )
                                                })
                                                :
                                                <MDBAlert color="success">
                                                    No Search result
                                                </MDBAlert>
                                            :
                                            searchQuery !== "" ?
                                                <div className={classes.SearchContentLoader}>
                                                    <ContentLoader
                                                        speed={2}
                                                        width={"100%"}
                                                        height={250}
                                                        backgroundColor="#f3f3f3"
                                                        foregroundColor="#ecebeb"
                                                    >
                                                        <rect x="5" y="5" rx="10" ry="10" width="350" height="220"/>
                                                    </ContentLoader>
                                                </div>
                                                : ""
                                    }
                                </div>

                            </div>
                        </div>
                    }
                </MDBCol>
            </MDBRow>

            <MDBRow>
                <MDBCol xl="12" lg="12" md="12" sm="12" xs="12">
                    <MDBTable>
                        <MDBTableHead color="primary-color" textWhite>
                            <tr>
                                <th>#</th>
                                <th>Category</th>
                                <th>Type</th>
                                <th>Title</th>
                                <th>Country Name</th>
                                <th>Action</th>
                            </tr>
                        </MDBTableHead>
                        <MDBTableBody>
                            {listScraper.map((e, index) => {
                                return (
                                    <ScraperItem
                                        newPendingRequest={newPendingRequest}
                                        key={e.id}
                                        data={e}
                                        setPendingItem={setPendingItem}
                                        rejectPendingItem={rejectPendingItem}
                                        index={index}
                                    />
                                )
                            })}
                        </MDBTableBody>
                    </MDBTable>
                </MDBCol>
            </MDBRow>
        </MDBContainer>
    )
}
export default ScraperPage